import { render, staticRenderFns } from "./OnboardingVettingPage.vue?vue&type=template&id=0867098a&scoped=true&"
import script from "./OnboardingVettingPage.vue?vue&type=script&lang=ts&"
export * from "./OnboardingVettingPage.vue?vue&type=script&lang=ts&"
import style0 from "./OnboardingVettingPage.vue?vue&type=style&index=0&id=0867098a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0867098a",
  null
  
)

export default component.exports